module.exports = __webpack_public_path__ + "static/media/Zoology.26c1abbf.svg";